import { Group } from '@mantine/core';
import { Text } from '@zorro/web/design-system';
import Image from 'next/image';

export const ImageFinchIntroPoweredBy = () => {
  return (
    <Group gap="4px" align="center">
      <Text size={'xs'} c={'zorroGray.4'}>
        Powered by
      </Text>
      <Image
        src="/images/finch.png"
        alt="Person sitting and waiting with coffee and laptop"
        width={34}
        height={10}
      />
    </Group>
  );
};
